module.exports = __webpack_public_path__ + "img/201705-1.f3b23448.jpeg";